import React from 'react';
//Context
import Divider from '@material-ui/core/Divider';
import { Fab } from '@material-ui/core';
import {
    PlayerPlay,
    ClockStop,
    PlayerPause,
    HandStop,
    PlayerRecord,
    PlayerStop,
} from 'tabler-icons-react';
import Chart from 'react-apexcharts';
import { useInfoCeldas } from './InfoCeldasContext';


export default function UpdateData() {
    const {
        detailOrder,
        detailCorrida,
        selectOrder,
        cant,
        status,
        startCorrida,
        isCorridaActive,
    } = useInfoCeldas();

    const ideal = [
        {
            data: [cant],
        },
    ];
    const series1 = [
        {
            data: [detailCorrida.producido],
        },
    ];

    const options = {
        chart: {
            type: 'bar',
            redrawOnParentResize: true,
            redrawOnWindowResize: true,
            offsetX: 30,
            offsetY: 0,
            toolbar: {
                show: false,
            },
        },
        tooltip: {
            enabled: true,

            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                return (
                    `${'<div class="arrow_box">' +
                    '<span>'}${ 
                    w.globals.labels[dataPointIndex] 
                    }: ${ 
                    series[seriesIndex][dataPointIndex] 
                    }</span>` +
                    `</div>`
                );
            },
            fixed: {
                enabled: true,
                position: 'topRight',
                offsetY: 20,
            },
        },
        colors: ['#472a7a'],
        grid: {
            show: true,
            xaxis: {
                lines: {
                    show: false,
                },
            },
            yaxis: {
                lines: {
                    show: true,
                },
            },
            padding: {
                top: 0,
                right: 0,
                bottom: 0,
            },
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                horizontal: true,
                barHeight: '90%',
            },
        },
        dataLabels: {
            enabled: false,
        },
        xaxis: {
            categories: ['Plan'],
            min: 0,
            max: detailOrder.meta,
            axisTicks: {
                show: false,
            },
            axisBorder: {
                show: true,
            },
            labels: {
                show: true,
                offsetY: 5,
                style: {
                    colors: [],
                    fontSize: '16px',
                    fontFamily: 'WorkSans',
                    fontWeight: 550,
                },
            },
        },
        yaxis: {
            labels: {
                show: true,
                style: {
                    colors: '#000',
                    fontSize: '18px',
                    fontFamily: 'WorkSans',
                    fontWeight: 600,
                },
            },
        },
    };

    const options1 = {
        chart: {
            type: 'bar',
            redrawOnParentResize: true,
            redrawOnWindowResize: true,
            offsetX: 30,
            offsetY: 0,
            toolbar: {
                show: false,
            },
        },
        tooltip: {
            enabled: true,

            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                return (
                    `${'<div class="arrow_box1">' +
                    '<span>'}${ 
                    w.globals.labels[dataPointIndex] 
                    }: ${ 
                    series[seriesIndex][dataPointIndex] 
                    }</span>` +
                    `</div>`
                );
            },
            fixed: {
                enabled: true,
                position: 'topRight',
                offsetY: -20,
                offsetX: 220,
            },
        },
        colors: ['#00A375'],
        grid: {
            show: true,
            xaxis: {
                lines: {
                    show: false,
                },
            },
            yaxis: {
                lines: {
                    show: true,
                },
            },
            padding: {
                top: 0,
                right: 0,
                bottom: 0,
            },
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                horizontal: true,
                barHeight: '90%',
            },
        },
        dataLabels: {
            enabled: false,
        },
        xaxis: {
            categories: ['Real'],
            min: 0,
            max: detailOrder.meta,
            axisTicks: {
                show: false,
            },
            axisBorder: {
                show: true,
            },
            labels: {
                show: false,
                offsetY: 3,
                style: {
                    colors: [],
                    fontSize: '16px',
                    fontFamily: 'WorkSans',
                    fontWeight: 600,
                },
            },
        },
        yaxis: {
            labels: {
                show: true,
                style: {
                    colors: '#000',
                    fontSize: '18px',
                    fontFamily: 'WorkSans',
                    fontWeight: 600,
                },
            },
        },
    };

    return (
        <>
            <div className="updateData-head">
                <div>
                    <h1 className="updateData-head-text">Estatus de la celda</h1>
                </div>
                <div
                    className="updateData-head-status"
                    style={{
                        display: startCorrida ? 'flex' : 'none',
                    }}
                >
                    <Fab
                        className={`updateData-head-status-button${status.codigo}`}
                        disabled
                        variant="extended"
                        size="small"
                    >
                        <ClockStop
                            size={25}
                            strokeWidth={1}
                            color={'black'}
                            style={{
                                display: status.codigo === 0 ? 'flex' : 'none',
                            }}
                        />
                        <PlayerPlay
                            size={25}
                            strokeWidth={1}
                            color={'black'}
                            style={{
                                display: status.codigo === 1 ? 'flex' : 'none',
                            }}
                        />
                        <PlayerPause
                            size={25}
                            strokeWidth={1}
                            color={'black'}
                            style={{
                                display: status.codigo === 2 ? 'flex' : 'none',
                            }}
                        />
                        <HandStop
                            size={25}
                            strokeWidth={1}
                            color={'black'}
                            style={{
                                display: status.codigo === 3 ? 'flex' : 'none',
                            }}
                        />
                        <HandStop
                            size={25}
                            strokeWidth={1}
                            color={'white'}
                            style={{
                                display: status.codigo === 4 ? 'flex' : 'none',
                            }}
                        />
                        <PlayerRecord
                            size={25}
                            strokeWidth={1}
                            color={'black'}
                            style={{
                                display: status.codigo === 5 ? 'flex' : 'none',
                            }}
                        />
                        <PlayerStop
                            size={25}
                            strokeWidth={1}
                            color={'black'}
                            style={{
                                display: status.codigo >= 6  ? 'flex' : 'none',
                            }}
                        />

                        <h1 className={`updateData-head-status-button-text${status.codigo}`}>
                            {status.nombre}
                        </h1>
                    </Fab>
                </div>
            </div>

            <Divider className="updateData-divider" />
            <div
                className="updateData-body"
                style={{
                    display: isCorridaActive || selectOrder ? 'flex' : 'none',
                }}
            >
                <div className="updateData-body-tittle">
                    <div className="updateData-body-tittle-block">
                        <h1>Meta planeada</h1>
                        <div className="updateData-body-text">
                            <h1 className="updateData-body-text-cantidad">{detailOrder.meta}</h1>
                        </div>
                    </div>
                    <div className="updateData-body-tittle-block-prod">
                        <h1>Producido</h1>
                        <div className="updateData-body-text">
                            <h1 className="updateData-body-text-prod">{detailCorrida.producido}</h1>
                        </div>
                    </div>
                    <div className="updateData-body-tittle-block">
                        <h1>Porcentaje</h1>
                        <div className="updateData-body-text">
                            <h1 className="updateData-body-text-porce">
                                {((detailCorrida.producido / detailOrder.meta) * 100).toFixed(1)}
                                {' %'}
                            </h1>
                        </div>
                    </div>
                </div>

                <div className="updateData-body-graph" style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%' }}>
                    <div>
                        <Chart
                            options={options}
                            series={ideal}
                            type="bar"
                            id="chart"
                            height={120}
                        />
                    </div>
                    <div
                        style={{
                            display:
                                process.env.REACT_APP_THEME === 'tecnoTheme' ? 'none' : 'block',
                        }}
                    >
                        <Chart
                            options={options1}
                            series={series1}
                            type="bar"
                            id="chart1"
                            height={120}
                        />
                    </div>
                </div>
                {/* <div className="updateData-body-buttons">
                    <div
                        style={{
                            display: auto ? 'none' : 'flex',
                            width: '100%',
                            justifyContent: 'center',
                        }}
                    >
                        <div
                            style={{
                                display: count ? 'none' : 'flex',
                                width: '100%',
                                justifyContent: 'center',
                            }}
                        >
                            <Button className="updateData-body-buttons-buena" variant="contained">
                                Pieza Buena
                            </Button>
                            <Button className="updateData-body-buttons-mala" variant="contained">
                                Pieza Mala
                            </Button>
                        </div>
                        <div
                            style={{
                                display: count ? 'flex' : 'none',
                                width: '100%',
                                justifyContent: 'center',
                            }}
                        >
                            <Button className="updateData-body-buttons-mala1" variant="contained">
                                Pieza Mala
                            </Button>
                        </div>
                    </div>
                </div> */}
            </div>
        </>
    );
}
